const DISPLAY_FILE_NAME_MAX = 36;

/** Display label for a contract review version, e.g. v1-20260916. */
export function formatReviewVersionLabel(
  versionNumber: number | null | undefined,
  createdAt: string | Date | null | undefined,
): string {
  const n = versionNumber ?? 1;
  if (createdAt == null || createdAt === "") {
    return `v${n}`;
  }

  const d = createdAt instanceof Date ? createdAt : new Date(createdAt);
  if (Number.isNaN(d.getTime())) {
    return `v${n}`;
  }

  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `v${n}-${y}${m}${day}`;
}

/** Basename for cards; strips paths, upload prefixes, and caps length. */
export function getReviewDisplayFileName(fileName: string | null): string {
  if (!fileName?.trim()) return "Untitled contract";

  let base = fileName.replace(/^.*[/\\]/, "").trim();
  base = base.replace(/^\d{10,}-[a-z0-9]+-/i, "");
  if (!base) return "Untitled contract";

  if (base.length <= DISPLAY_FILE_NAME_MAX) return base;

  const extMatch = base.match(/(\.[a-z0-9]{1,8})$/i);
  const ext = extMatch?.[1] ?? "";
  const stem = ext ? base.slice(0, -ext.length) : base;
  const keep = DISPLAY_FILE_NAME_MAX - ext.length - 1;
  if (keep < 8) return `${base.slice(0, DISPLAY_FILE_NAME_MAX - 1)}…`;
  return `${stem.slice(0, keep)}…${ext}`;
}
